module.exports = __webpack_public_path__ + "static/media/futuregrad_logotype_white.f4848361.svg";